/*
 * IMPORTS
 */
import { gql } from "@apollo/client"; // NPM: Apollo client for handling graphql request.

/*
 * GRAPH
 */
const Index = gql`
  mutation MyMutation($podcastSummaryId: ID!) {
    PodcastDelete(podcastSummaryId: $podcastSummaryId) {
      message
      status
    }
  }
`;

/*
 * EXPORTS
 */
export default Index;
